import React from "react";

export default function ProfessiogrammaPagination({
  setPage,
  current_page,
  total_pages,
}) {
  function handlePrevious() {
    current_page = current_page - 1;
    console.log(current_page);
    setPage(current_page);
  }
  function handleNext() {
    current_page = current_page + 1;
    setPage(current_page);
  }
  if (total_pages >= 2) {
    return (
      <div>
        <div className="pagination">
          <input
            className="btn btn-success"
            type="button"
            value="orqaga"
            onClick={handlePrevious}
          />
          <input
            className="btn btn-success"
            type="button"
            value="oldinga"
            onClick={handleNext}
          />
        </div>
      </div>
    );
  } else {
    return null
  }

}
